import { gql } from "@apollo/client"
export const GET_FARMS_SUBSCRIPTION = gql`
  subscription GetFarmsSubscription {
    farm(where: { archived_at: { _is_null: true } }) {
      name
      id
      date_created
      properties
      wave_buoy_to_farms {
        wave_buoy {
          id
          name
          wave_buoy_data(
            where: { measurement: { _in: ["SST (degC)", "Hsig (m)"] } }
            limit: 100
            order_by: { measurement_date: desc }
          ) {
            measurement_date
            measurement
            value
          }
        }
      }
      geo_location {
        geo_json
        id
      }
    }
  }
`
